const requiredRegionCountries = [
  'United States',
  'Canada',
  'Australia',
  'Brazil',
  'Japan',
  'Mexico',
];

const requiredRegionCountriesCode = ['US', 'CA', 'AU', 'BR', 'JP', 'MX'];

module.exports = {
  requiredRegionCountries,
  requiredRegionCountriesCode,
};
